import dayjs from "dayjs";
import { useEffect, useState } from "react";
import EventForm from "./EventForm";
import ListShort from "components/ui/atoms/ListShort";
import EventListItemShort from "models/actions/EventListItemShort";
import { useAllAction } from "models/actions/apiAction";
import { useModal } from "@ebay/nice-modal-react";

const defaultFilter = {
  action_type: "event",
  ordering: "date",
};

const EventWidget = ({ userId }) => {
  const [state, setState] = useState({
    filter: { date__date: dayjs().format("YYYY-MM-DD") },
    offset: 0,
  });
  const [fetchParams, setFetchParams] = useState(null);
  const actionModal = useModal("ActionDrawer");
  const { data: events, status, error } = useAllAction(fetchParams);

  useEffect(
    () =>
      setFetchParams({
        ...defaultFilter,
        ...state.filter,
        account__user: userId,
      }),
    [state],
  );

  return (
    <>
      <ListShort
        title="Events"
        emptyMessage="No Events"
        resource={events}
        resourceStatus={status}
        state={state}
        setState={setState}
        ListItemComponent={EventListItemShort}
        FilterForm={EventForm}
        primaryClick={(event) => actionModal.show({ id: event.id })}
        error={error}
      />
    </>
  );
};

export default EventWidget;
